import { render, staticRenderFns } from "./DetalleFichaje.vue?vue&type=template&id=2f640fab"
import script from "./DetalleFichaje.vue?vue&type=script&lang=js"
export * from "./DetalleFichaje.vue?vue&type=script&lang=js"
import style0 from "./DetalleFichaje.vue?vue&type=style&index=0&id=2f640fab&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports